import { push } from 'connected-react-router';
import { useTranslation } from 'react-i18next';
// Types
import CaseStatuses from 'app/types/CaseStatuses';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectPendingCasesLength } from 'app/store/Cases/Cases.selectors';
// Mui
import { Theme, Toolbar, Grid, Typography, Tabs, Badge } from '@mui/material';
// Components
import { Tab } from 'app/components/Mui';
// Utils
import useCasesContext from './utils/useCasesContext';

const CasesToolbar = () => {
  const { t } = useTranslation();

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const pendingCasesLength:number = useAppSelector(selectPendingCasesLength);

  const { params, onChangeParams } = useCasesContext();

  const handleChange = (_:any, newStatusTab:CaseStatuses) => {
    if ( !params ) return;
    const nextParams = {
      ...params,
      offset: 0,
      status: newStatusTab,
      'invoice.status': 'all'
    };
    onChangeParams(nextParams);
    dispatch(push({ search: `tab=${newStatusTab}` }));
  }

  const typeLabels:Record<CaseStatuses, string> = {
    [CaseStatuses.Archived]: t('pages.cases.archivedType'),
    [CaseStatuses.CreationInProgress]: t('pages.cases.creationInProgressType'),
    [CaseStatuses.Open]: t('pages.cases.openType'),
    [CaseStatuses.Pending]: t('pages.cases.pendingType'),
    [CaseStatuses.Rejected]: t('pages.cases.rejectedType'),
    [CaseStatuses.Waiting]: t('pages.cases.waitingForRecordsType')
  }

  if ( !params ) return null;
  return (
    <Toolbar variant="dense">
      <Grid container sx={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
        <Grid size={{ xs: 2 }}>
          <Typography variant="h6">{t('pages.cases.title')}</Typography>
        </Grid>
        <Grid size={{ xs: 8 }}>
          <Tabs value={params.status} onChange={handleChange} centered>
            {(Object.values(CaseStatuses) as CaseStatuses[]).map((type) => {
              if ( type === CaseStatuses.CreationInProgress ) return null;
              return (
                <Tab
                  name={type}
                  key={`case-tab-item-${type}`}
                  sx={{
                    '&:hover': {
                      bgcolor: (theme:Theme) => theme.palette.primary.light
                    }
                  }}
                  value={type}
                  label={
                    type === CaseStatuses.Pending
                      ? 
                        <Badge badgeContent={pendingCasesLength} color="primary">
                          &nbsp;&nbsp;{typeLabels[type]}&nbsp;&nbsp;
                        </Badge>
                      : typeLabels[type]
                  }
                />
              )
            })}
          </Tabs>
        </Grid>
        <Grid size={{ xs: 2 }} />
      </Grid>
    </Toolbar>
  )
}

export default CasesToolbar;
